import api from "../../../api/api";


const getDD = () =>{
    return new Promise((resolve, reject)=>{
        api.get("/dd/user-role").then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const userRoleServices = {
    getDD,
}
export default userRoleServices;